import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core'
import { Validatable } from './validatable'
import { FieldValidator } from './field-validator'
import { FormValidationService } from './form-validation-service'
import { ValidatedSelectOptionModel } from './validated-dropdown.component'

@Component({
    selector: 'ValidatedMultiSelect',
    templateUrl: './html-templates/validated-multi-select.component.html'
})
export class ValidatedMultiSelect extends Validatable<string[]> implements OnChanges {
    @Input() label = ''
    @Input() options: ValidatedSelectOptionModel[]
    @Input() validators: FieldValidator<string[]>[] = []
    @Output() onValueChange: EventEmitter<string[]> = new EventEmitter<string[]>()
    @Input() selectedValues: string[] = []
    @Input() disabled: boolean

    constructor(formValidationService: FormValidationService) {
        super(formValidationService)
    }

    updateSelection(options: HTMLOptionElement[]) {
        this.selectedValues = this.valuesFromOptions(options)
        this.onValueChange.emit(this.selectedValues)
        this.validate()
    }

    onBlur(): void {
        this.validate()
    }

    getValue(): string[] {
        return this.selectedValues
    }

    getLabel(): string {
        return this.label
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.disabled && changes.disabled.currentValue) {
            this.clearValidationErrors()
        }
        if (changes.selectedValues && changes.selectedValues.currentValue) {
            this.selectedValues = changes.selectedValues.currentValue
        }
    }

    isSelected(option: HTMLOptionElement): boolean {
        return this.selectedValues.indexOf(option.value) >= 0
    }

    private valuesFromOptions(options: HTMLOptionElement[]): string[] {
        return Array.apply(null, options)
            .filter((option: any) => option.selected)
            .map((option: any) => option.value)
    }
}
